class IntegrationStatusController {

    constructor(integrationApiService) {
        this.integrationApiService = integrationApiService;
    }

    $onInit () {
        this.loading = [
            'spadays',
            'treatments',
            'extras'
        ];

        this.events = {};

        this.tags = {
            'spadays': 'Spa Days/Packages',
            'treatments': 'Treatments/Appointments',
            'extras': 'Event Extras/Non-Stock Items'
        };

        this.onlyUnlinked = false;

        return Promise.all([
            this.getSpadays(),
            this.getTreatments(),
            this.getExtras()
        ]);
    }

    mapLinks (data) {
        data.revspa.map(event => {
            if (event.integration_identity) {
                let integrationEvent = data.integration.find(integrationEvent => parseInt(integrationEvent.integration_identity) === parseInt(event.integration_identity));
                if (integrationEvent) {
                    event.linked = integrationEvent.name;
                    integrationEvent.linked = true;
                }
            }
            return event;
        });

        return data;
    }

    getSpadays () {
        return this.integrationApiService.getIntegrationStatus('spadays').then(data => {
            if (data.revspa.length || data.integration.length) {
                this.events.spadays = this.mapLinks(data);
            }
            this.stopLoading('spadays');
        });
    }

    getTreatments () {
        return this.integrationApiService.getIntegrationStatus('treatments').then(data => {
            if (data.revspa.length || data.integration.length) {
                this.events.treatments = this.mapLinks(data);
            }
            this.stopLoading('treatments');
        });
    }

    getExtras () {
        return this.integrationApiService.getIntegrationStatus('extras').then(data => {
            if (data.revspa.length || data.integration.length) {
                this.events.extras = this.mapLinks(data);
            }
            this.stopLoading('extras');
        });
    }
    stopLoading (tag) {
        const index = this.loading.indexOf(tag);
        if (index > -1) {
            this.loading.splice(index, 1);
        }
    }

    isLoading (tag) {
        return this.loading.indexOf(tag) > -1;
    }
}

IntegrationStatusController.$inject = ['integrationApiService'];

export default IntegrationStatusController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/integration/controllers/integration.status.controller.js